<template>
  <div class="dataModel" :style="heightStyle" ref="datamodel">
    <!-- <el-row>
    <el-col :lg="12" :md="24" :sm="24">-->
      <div class="header-nav">
        <div class="back-btn" @click="popBack"><i class="el-icon-back"></i></div> <div class="list-title">{{$store.state.wechat.dcpTemplate.name}}</div>
      </div>
    <div class="modelContent" v-loading="loading">
      <el-form  :model="cbJson" ref="form">
        <render
                :jsonContent="template"
                :datamodel="datamodel"
                :referenceList="referenceList"
                @fatherCall="setUpdateJSON"
                @dcpDetail="viewDcpDetail"
                @updateRefDcu="updateRefDcuData"
                @cacheDatamodel="cacheDatamodelData"
                ref="childComponents"
                :disabled="disabled || (update && formStatus && formStatus.indexOf('edit') > -1)"
                :contextData="contextData"
                :editStatus="editStatus"
        />
      </el-form>
    </div>

    <div class="bottom-container">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col v-if="formStatus && formStatus.indexOf('edit') > -1 && update">
          <el-button
            class="btn-white-color"
            @click="begUpdate"
            :disabled="disabled"
            round
          >{{$t('app.update')}}</el-button>
        </el-col>
        <el-col :span="11" v-if="formStatus && formStatus.indexOf('edit') < 0 || !update">
          <el-button
            class="btn-white-color"
            @click="onSave"
            :disabled="disabled"
            round
          >{{$t('app.btn_save_draft')}}</el-button>
        </el-col>
        <el-col :span="11" v-if="formStatus && formStatus.indexOf('edit') < 0 || !update">
          <el-button
            class="btn-black-color"
            @click="onSubmit"
            :disabled="disabled"
            round
          >{{$t('app.btn_submit')}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import callApp from "@/services/sdk";
import render from "@/pages/dcpdetail/render";
import dcp1Nodata from "@/localdata/dcp1-nodata";
import dcp1Withdata from "@/localdata/dcp1-withdata";
import componentData from "@/localdata/component-test";
import componentWithData from "@/localdata/component-test-with-data";
import bindsku from "@/localdata/bindsku";
import customEdit from "@/localdata/custom_edit";
import collectionBind from "@/localdata/collectionBind";
import testTrack from "@/localdata/test-track";
// import refdcp from '@/localdata/refdcpwithdata';
import refcfglist from '@/localdata/refconfiglist';
import customDcp from '@/localdata/custom_edit';
import refdcp from '@/localdata/testvids';
import plantJson from '@/localdata/plant';
import vetrustTpl from '@/localdata/vetrust-test';
import utils from '@/utils/domain'
import { mapGetters } from 'vuex'
import { Indicator } from 'mint-ui'

import Axios from 'axios'
const axios = Axios.create({ })

export default {
  name: "index",
  components: {
    render,
    Indicator
  },
  data() {
    return {
      template: "",
      datamodel: "",
      cbJson: {},
      // formStatus: "",
      update: true,
      // disabled: false,
      checkStatus: true,
      needCheckDeepth: 1,
      checkFinishDeepth: 0,
      referenceList: "",
      receivedDcp: "",
      refDcpConfigList: [],
      dcpreferences: [],
      catchError:"",
      scroll: 0,
      recordData: "",
      bizId: '',
      // contextData: {},
      vwHeight: 0,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
        formSet: 'getFormSet',
        formStatus: 'getFormStatus',
        softDataStatus: 'getSoftDataStatus',
        dataPointType: 'getDataPointType'
			}),
    disabled() {
      return (
              this.formStatus === 'submitedit'
              && (this.dataPointType === 'collectionUnBind' || this.dataPointType === 'collectionBind')
              || this.softDataStatus === 'disable'
      )
    },
    heightStyle() {
      return 'min-height:'+ this.vwHeight + 'vw'
    },
    bodyStyle() {
      return 'height: calc('+ this.vwHeight + 'vw' + '- 80px)';
    },
    contextData() {
      return {
        "refDcpConfigList": this.refDcpConfigList,
        "dcpreferences": this.dcpreferences
      }
    },
     editStatus() {
				if(this.formStatus && this.formStatus.indexOf('edit') > -1 && this.update) {
					return "watch"
				} else if(this.formStatus && this.formStatus.indexOf('init') > -1) {
					return "init"
				} else if(this.formStatus && this.formStatus.indexOf('edit') > -1) {
					return "edit"
				}
				return "watch"
			}
  },
  beforeRouteLeave(to, from, next) {
      let position = document.documentElement && document.documentElement.scrollTop; //记录离开页面时的位置

      if (position == null) position = 0
      this.$store.state.indexScroll = position
      next()
  },

  mounted() {

    try {
          let wechat = this.$route.query.wechat
          if(wechat){
            
            document.cookie = "x-api-token=" + this.$store.state.loginToken +";path=/;domain=" + utils.getCookieDomain()
            
            let bizDataId = this.$route.query.bizDataId
            let dataUuid = this.$route.query.dataUuid

            if(dataUuid && bizDataId){
              this.getRemoteDcpTemplate()
            }else{
              this.$store.dispatch(
                "setFormStatus", "init"
              );
              this.$store.dispatch("setDataPointType", this.$route.query.statusData_dcpType);
              this.$store.dispatch(
                "setSoftDataStatus",
                this.$route.query.statusData_softDataStatus || "enable"
              );
              console.log("update_status",this.formStatus)

              this.template = this.$store.state.wechat.dcpTemplate && this.$store.state.wechat.dcpTemplate.attributes

              console.log("template", JSON.stringify(this.template));
            }
            
          }else{ }

    } catch (err) {
      this.catchError = err
    }
  },
  methods: {
    popBack() {
      this.$router.back()
    },
    showLoading() {
      Indicator.open();
    },
    dismissLoading() {
      Indicator.close();
    },
    setUpdateJSON(data) {
      this.cbJson = data.value;
      // console.log("receivejson", data);
      this.$forceUpdate();
      // this.cbJson[data.key] = data.value || {};
    },
    cacheDatamodelData(){
        this.$store.state.cacheData = this.cbJson
    },
    updateRefDcuData(data){
      let action = data.action
      let refData = data.refData
      let storagekey = refData.storagekey
      if(!this.dcpreferences || this.dcpreferences === undefined) {
        this.dcpreferences = []
      }
      this.dcpreferences = this.dcpreferences && this.dcpreferences.filter(element => {
        return element.storagekey !== storagekey
      }) || []
      if(action === "update") {
        this.dcpreferences.push(refData)
      }
    },
    resetCheckStatus() {
      this.checkStatus = true;
      this.needCheckDeepth = 1;
      this.checkFinishDeepth = 0;
    },

    onSave() {
      // console.log("forms", this.$refs.form)
      this.$store.state.cacheData = {}
      this.$store.dispatch('setViewDcp', {})
      this.$store.dispatch('setChildPageContext', {})
      this.$store.state.preEditDataModelUuid = ''
      this.$store.state.preEditStatus = true
      this.save();

    },

    onSubmit() {
      this.$store.state.cacheData = {}
      this.$store.dispatch('setViewDcp', {})
      this.$store.dispatch('setChildPageContext', {})
      this.$store.state.preEditDataModelUuid = ''
      this.$store.state.preEditStatus = true
      // getViewDcp
      this.resetCheckStatus();
      this.checkFormSubmit(this.$refs.childComponents.$refs, false);
    },

    submit() {
      let json = {...this.cbJson, dcpreferences: this.dcpreferences}
      let uploadData = JSON.parse(JSON.stringify(json));
      
      let bizDataId = this.$route.query.bizDataId
      
      let submitData = {
        bizDataType: "DATAPOINT",
        projectId: this.$store.state.wechat.projectId,
        instanceUuid: this.$store.state.wechat.instanceUuid,
        dataValue: uploadData,
        datamodelUuid: this.$store.state.wechat.datamodelUuid,
        bizLanguage: "zh-CN",
        version: this.$store.state.wechat.version,
        dataStatus: "SUBMIT",
        bizDataId
      }
      this.loading = true
      Indicator.open()
      axios.defaults.withCredentials = true
      axios({
        url: utils.getDomain() + '/standard/submit',
        method: 'POST',
        headers: {
          'x-api-token': this.$store.state.loginToken,
          'Content-Type': "application/json"
        },
        data: submitData
      })
      .then(({ data }) => {
        console.log("resp_data", data)
        this.loading = false
        Indicator.close()
        console.log("resp_data", data)
        if(data.code === 'common.success') {
          this.$toast("数据提交成功, 请到记录中查看")
          // this.$router.push({path:""})
        }
        /// toast success and refersh
      })
      .catch(( error ) => {
        this.loading = false
        console.log("error_occur", error)
      })
    },

    save() {
      let json = {...this.cbJson, dcpreferences: this.dcpreferences}
      let uploadData = JSON.parse(JSON.stringify(json));
      let bizDataId = this.$route.query.bizDataId

      let submitData = {
        bizDataType: "DATAPOINT",
        projectId: this.$store.state.wechat.projectId,
        instanceUuid: this.$store.state.wechat.instanceUuid,
        dataValue: uploadData,
        datamodelUuid: this.$store.state.wechat.datamodelUuid,
        bizLanguage: "zh-CN",
        version: this.$store.state.wechat.version,
        dataStatus: "DRAFT",
        bizDataId
      }
      /// show loading
      this.loading = true
      Indicator.open()
      axios.defaults.withCredentials = true
      axios({
        url: utils.getDomain() + '/standard/submit',
        method: 'POST',
        headers: {
          'x-api-token': this.$store.state.loginToken,
          'Content-Type': "application/json"
        },
        data: submitData
      })
      .then(({ data }) => {
        /// dismiss loading
        this.loading = false
        Indicator.close()
        console.log("resp_data", data)
        if(data.code === 'common.success') {
          this.$toast("数据提交成功, 请到记录中查看")
          // this.$router.push({path:""})
        }
        /// toast success and refersh
      })
      .catch(( error ) => {
        this.loading = false
        console.log("error_occur", error)
      })

    },
    getRemoteDcpTemplate(){
      
      let token = this.$store.state.loginToken
      let processCode = this.$store.state.wechat.processCode
      let modelUuid = this.$store.state.wechat.datamodelUuid
      let version = this.$store.state.wechat.version
      axios.defaults.withCredentials = true

      token && axios({
        url: utils.getDomain() + '/builderapp/dcpDetail',
        method: 'GET',
        headers: {
          'x-api-token': token,
          'Content-Type':'application/json'
        },
        params: {
          processCode,
          modelUuid,
          version
        }
      })
      .then(({ data }) => {
        console.log("resp_tpl_data", data)
        this.loading = false
        if(data.code === 'common.success') {

          this.$store.state.wechat.dcpTemplate = data.data.modelDetail.model
          this.getRemoteDcpData()
        }
      })
      .catch(( error ) => {
        this.loading = false
        console.log("error_occur", error)
      })
    },
    getRemoteDcpData(){
      let dataUuid = this.$route.query.dataUuid
      this.bizId = this.$route.query.bizDataId
      /// get data
      let token = this.$store.state.loginToken
      let instanceUuid = this.$store.state.wechat.instanceUuid
      let datamodelUuid = this.$store.state.wechat.datamodelUuid
      let projectId = this.$store.state.wechat.projectId
      axios.defaults.withCredentials = true

      token && axios({
        url: utils.getDomain() + '/query/detail',
        method: 'POST',
        headers: {
          'x-api-token': token,
          'Content-Type':'application/json'
        },
        data: {
          datamodelUuid,
          instanceUuid,
          projectId,
          dataUuid
        }
      })
      .then(({ data }) => {
        console.log("resp_data", data)
        this.loading = false
        if(data.code === 'common.success') {
          
          this.template = this.$store.state.wechat.dcpTemplate && this.$store.state.wechat.dcpTemplate.attributes
          this.datamodel = data.data.dataInfo.dataValue
        // 获取URL中传入的历史数据状态
        // statusData_softDataStatus: softDataStatus,
        // statusData_editStatus: editStatus,
        // statusData_dcpType: dcpType
          this.$store.dispatch(
                "setFormStatus",
                this.$route.query.statusData_editStatus || "edit"
              );
          this.$store.dispatch("setDataPointType", this.$route.query.statusData_dcpType);
          this.$store.dispatch(
            "setSoftDataStatus",
            this.$route.query.statusData_softDataStatus || "enable"
          );
          console.log("this.datamodel_", this.datamodel)
        }
      })
      .catch(( error ) => {
        this.loading = false
        console.log("error_occur", error)
      })

      /// get data
    },
    checkFormSubmit(check, outStatus) {
      if (check.childComponents !== undefined) {
        for (let index = 0; index < check.childComponents.length; index++) {
          const item = check.childComponents[index];
          if (item.$refs.childComponents !== undefined) {
            this.needCheckDeepth += 1;
            this.checkFormSubmit(item.$refs, false);
          } else if (item.$refs.childForm !== undefined) {
            item.$refs.childForm.validate(validateResult => {
              this.checkStatus = this.checkStatus && validateResult;
              return this.checkStatus;
            });
          }
        }
        this.checkFinishDeepth += 1;

        /// 根据检查层级判断有没有检查完
        if (
          this.checkFinishDeepth > 1 &&
          this.needCheckDeepth === this.checkFinishDeepth
        ) {
          console.log("check all finish");
          if (this.checkStatus) {
            console.log("validate all pass");
            this.submit();
            /// call app save
          } else {
            console.log("validate not pass");
          }
        }
      }
    },
    begUpdate() {
      this.update = false;

      /// update to state
      this.$store.state.preEditDataModelUuid = this.recordData.base && this.recordData.base.timestamp || ''
      this.$store.state.preEditStatus = false
    },
    viewDcpDetail(dcp) {
      this.receivedDcp = dcp
      // this.$router
      // this.$state
      this.$store.dispatch('setViewDcp', dcp)
      this.$router.push({path: "/v2/dcpdetail",query: { action: "update" }})
    }
  },
  beforeMount () {
    let h = document.body.clientHeight || document.documentElement.clientHeight;
    let w = document.body.clientWidth || document.documentElement.clientWidth;
    this.vwHeight = (h/w)*100;
  }
};
</script>
<style lang="scss" scoped>
.dataModel {
  display: flex;
  height: 100vh;
  flex-direction: column;
  padding: 0 10px;
  margin: 0 auto;
  max-width: 750px;

  .modelContent {
    flex: 1 0 auto;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(180vw - 60px);
    min-height: calc(180vw - 60px);
  }

  .bottom-container {
    padding: 10px;
    margin: 0;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1002;
  }
}

.box-card {
  .el-card__body {
    height: calc(100vh - 360px);
    overflow-y: scroll;

    .no-data {
      text-align: center;
      opacity: 0.5;
    }

    .scan-result {
      padding: 10px 0px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid lightgrey;

      .left {
        word-break: break-word;
      }

      .right {
        text-align: right;
        width: 90px;
      }
    }
  }
}

.header-nav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  i {
    width: 20px;
    height: 20px;
  }
  .back-btn {
    padding: 10px;
    height: 20px;
    font-size: 16px;
  }
  .list-title {
    padding: 10px;
    height: 20px;
    color: #999;
    font-size: 16px;
    // position: sticky;
  }
}


</style>

